import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';

export const TaskDescriptionTip = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	return (
		<Text size="small" color="color.text.subtlest">
			{children}
		</Text>
	);
};
